export default __webpack_public_path__ + "static/media/vbb-1.fe6b1713.jpg";